export function initNewRelic() {
  if ((window as any).__NR_LOADER_INITIALIZED__) {
    console.log("⚠️ New Relic loader already initialized, skipping...");
    return;
  }

  (window as any).__NR_LOADER_INITIALIZED__ = true;

  const nrScript = document.createElement("script");
  nrScript.src = "https://js-agent.newrelic.com/nr-loader-spa-current.min.js";
  nrScript.async = true;

  (window as any).NREUM = {
    init: {
      distributed_tracing: {
        enabled: true,
        cors_use_newrelic_header: true,
        cors_use_tracecontext_headers: true,
        allowed_origins: JSON.parse(
          import.meta.env.VITE_NEW_RELIC_WIDGET_ALLOWED_DOMAINS || "[]"
        ),
      },
      privacy: {
        cookies_enabled: true,
      },
      session_replay: {
        enabled: true,
        block_selector: "",
        mask_text_selector: "*",
        sampling_rate: 10,
        error_sampling_rate: 100,
        mask_all_inputs: true,
        collect_fonts: true,
        inline_images: false,
        fix_stylesheets: true,
        preload: false,
        mask_input_options: {},
      },
    },
    loader_config: {
      accountID: import.meta.env.VITE_NEW_RELIC_WIDGET_ACCOUNT_ID,
      trustKey: import.meta.env.VITE_NEW_RELIC_WIDGET_TRUST_KEY,
      agentID: import.meta.env.VITE_NEW_RELIC_WIDGET_APPLICATION_ID,
      licenseKey: import.meta.env.VITE_NEW_RELIC_WIDGET_LICENSE_KEY,
      applicationID: import.meta.env.VITE_NEW_RELIC_WIDGET_APPLICATION_ID,
    },
    info: {
      beacon: "bam.eu01.nr-data.net",
      errorBeacon: "bam.eu01.nr-data.net",
      licenseKey: import.meta.env.VITE_NEW_RELIC_WIDGET_LICENSE_KEY,
      applicationID: import.meta.env.VITE_NEW_RELIC_WIDGET_APPLICATION_ID,
      sa: 1,
    },
  };

  document.head.appendChild(nrScript);

  console.log("✅ New Relic Browser loader injected");
}